(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-tiktok-carousel"] && !Shopify.designMode) return;
  try {
    
  class ShoppableTikTokCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;
      this.observePlayers();
      this.bindNavigation();
      this.bindVariants();
      this.updateNavigation();
    }

    observePlayers() {
      this.playerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const iframe = entry.target.querySelector('iframe[data-player-src]');
          if (!iframe) return;
          if (entry.isIntersecting) {
            if (!iframe.src) iframe.src = iframe.dataset.playerSrc;
          } else if (iframe.src) {
            iframe.contentWindow?.postMessage({ type: 'pause', value: null, 'x-tiktok-player': true }, 'https://www.tiktok.com');
          }
        });
      }, { root: this.track, rootMargin: '100% 100%', threshold: 0.25 });
      this.querySelectorAll('[data-carousel-card]').forEach((card) => this.playerObserver.observe(card));
    }

    bindNavigation() {
      this.previousButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
      this.resizeObserver.observe(this.track);
    }

    bindVariants() {
      this.querySelectorAll('[data-variant-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.closest('form');
          const option = select.selectedOptions[0];
          const input = form?.querySelector('[data-variant-input]');
          const quantityInput = form?.querySelector('[data-quantity-input]');
          const productForm = form?.closest('product-form-component');
          const price = select.closest('[data-carousel-card]')?.querySelector('[data-variant-price]');
          const button = form?.querySelector('[name="add"]');
          if (input) input.value = option.value;
          if (input) input.disabled = option.dataset.available !== 'true';
          if (quantityInput) quantityInput.value = option.dataset.minimumQuantity || '1';
          if (productForm) productForm.dataset.quantityDefault = option.dataset.minimumQuantity || '1';
          if (price) price.textContent = option.dataset.price;
          if (button) button.disabled = option.dataset.available !== 'true';
        });
      });
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('[data-carousel-card]');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    updateNavigation() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
    }

    disconnectedCallback() {
      this.playerObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }
  }

  if (!customElements.get('shoppable-tiktok-carousel')) {
    customElements.define('shoppable-tiktok-carousel', ShoppableTikTokCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squishcraft-faq"] && !Shopify.designMode) return;
  try {
    
  class SquishcraftFaq extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.tabs = [...this.querySelectorAll('[data-faq-tab]')];
      this.panels = [...this.querySelectorAll('[data-faq-panel]')];
      if (!this.tabs.length) return;
      this.classList.add('is-enhanced');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-faq-panel]');
        if (!panel) return;
        const tab = this.tabs.find((candidate) => candidate.dataset.category === panel.dataset.category);
        if (tab) this.selectTab(tab);
      });
      this.selectTab(this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
    }

    selectTab(tab, setFocus = false) {
      this.tabs.forEach((candidate) => {
        const selected = candidate === tab;
        candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
        candidate.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.category !== tab.dataset.category;
      });
      if (setFocus) tab.focus();
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;
      event.preventDefault();
      this.selectTab(this.tabs[nextIndex], true);
    }
  }

  if (!customElements.get('squishcraft-faq')) {
    customElements.define('squishcraft-faq', SquishcraftFaq);
  }

  } catch(e) { console.error(e); }
})();
})();
